import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@sanlam-glacier/app-common/components';
import { format } from 'date-fns';
import { TransactionModelMock } from 'modules/clients/types/client.interfaces';
import styles from './transaction-detail-table.module.scss';
import clsx from 'clsx';

type TransactionDetailTableProps = {
  transactions: TransactionModelMock[];
  totalSourceAmount: number;
  totalTargetAmount: number;
};

export const TransactionDetailTable = ({
  transactions,
  totalSourceAmount,
  totalTargetAmount
}: TransactionDetailTableProps) => {
  return (
    <Table>
      <TableHead className={styles.tableHeaderRow}>
        <TableRow>
          <TableCell align={TableCell.ALIGN.LEFT} className={styles.tableCells}>
            <Typography
              variant={Typography.VARIANT.B4}
              weight={Typography.WEIGHT.MEDIUM}
              className={clsx(styles.tableHeaderRowHeadings, styles.dateColumnWidth)}
              color={Typography.COLOR.INHERIT}
            >
              Date
            </Typography>
          </TableCell>
          <TableCell align={TableCell.ALIGN.LEFT} className={styles.tableCells}>
            <Typography
              variant={Typography.VARIANT.B4}
              weight={Typography.WEIGHT.MEDIUM}
              className={styles.tableHeaderRowHeadings}
              color={Typography.COLOR.INHERIT}
            >
              Investment option
            </Typography>
          </TableCell>
          <TableCell align={TableCell.ALIGN.LEFT} className={styles.tableCells}>
            <Typography
              variant={Typography.VARIANT.B4}
              weight={Typography.WEIGHT.MEDIUM}
              className={styles.tableHeaderRowHeadings}
              color={Typography.COLOR.INHERIT}
            >
              Component
            </Typography>
          </TableCell>
          <TableCell
            align={TableCell.ALIGN.RIGHT}
            className={clsx(styles.amountTableCells, styles.amountColumnWidth)}
          >
            <Typography
              variant={Typography.VARIANT.B4}
              weight={Typography.WEIGHT.MEDIUM}
              className={styles.tableHeaderRowHeadings}
              color={Typography.COLOR.INHERIT}
              align={Typography.ALIGN.RIGHT}
            >{`Amount (R/c)`}</Typography>
            <Typography
              variant={Typography.VARIANT.B4}
              weight={Typography.WEIGHT.NORMAL}
              className={styles.tableHeaderRowHeadings}
              color={Typography.COLOR.INHERIT}
              align={Typography.ALIGN.RIGHT}
            >
              Source
            </Typography>
          </TableCell>
          <TableCell
            align={TableCell.ALIGN.RIGHT}
            className={clsx(styles.amountTableCells, styles.amountColumnWidth)}
          >
            <Typography
              variant={Typography.VARIANT.B4}
              weight={Typography.WEIGHT.MEDIUM}
              className={styles.tableHeaderRowHeadings}
              color={Typography.COLOR.INHERIT}
              align={Typography.ALIGN.RIGHT}
            >{`Amount (R/c)`}</Typography>
            <Typography
              variant={Typography.VARIANT.B4}
              weight={Typography.WEIGHT.NORMAL}
              className={styles.tableHeaderRowHeadings}
              color={Typography.COLOR.INHERIT}
              align={Typography.ALIGN.RIGHT}
            >
              Target
            </Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {transactions.map((transaction) => (
          <TableRow key={transaction.transactionId}>
            <TableCell
              className={clsx(styles.tableEntryRows, styles.dateColumnWidth)}
              align={TableCell.ALIGN.LEFT}
            >
              <Typography
                variant={Typography.VARIANT.B4}
                weight={Typography.WEIGHT.NORMAL}
                color={Typography.COLOR.DEFAULT}
              >
                {format(transaction.transactionDate, 'yyyy-MM-dd')}
              </Typography>
            </TableCell>
            <TableCell className={styles.tableEntryRows} align={TableCell.ALIGN.LEFT}>
              <Typography
                variant={Typography.VARIANT.B4}
                weight={Typography.WEIGHT.NORMAL}
                color={Typography.COLOR.DEFAULT}
              >
                {transaction.investmentOption}
              </Typography>
            </TableCell>
            <TableCell className={styles.tableEntryRows} align={TableCell.ALIGN.LEFT}>
              <Typography
                variant={Typography.VARIANT.B4}
                weight={Typography.WEIGHT.NORMAL}
                color={Typography.COLOR.DEFAULT}
              >
                {transaction.component ? transaction.component : '--'}
              </Typography>
            </TableCell>
            <TableCell
              className={clsx(styles.tableEntryRows, styles.amountColumnWidth)}
              align={TableCell.ALIGN.RIGHT}
            >
              <Typography
                variant={Typography.VARIANT.B4}
                weight={Typography.WEIGHT.NORMAL}
                color={Typography.COLOR.DEFAULT}
                align={Typography.ALIGN.RIGHT}
              >
                {transaction.amountSource ? transaction.amountSource.toFixed(2) : '--'}
              </Typography>
            </TableCell>
            <TableCell
              className={clsx(styles.tableEntryRows, styles.amountColumnWidth)}
              align={TableCell.ALIGN.RIGHT}
            >
              <Typography
                variant={Typography.VARIANT.B4}
                weight={Typography.WEIGHT.NORMAL}
                color={Typography.COLOR.DEFAULT}
                align={Typography.ALIGN.RIGHT}
              >
                {transaction.amountTarget ? transaction.amountTarget.toFixed(2) : '--'}
              </Typography>
            </TableCell>
          </TableRow>
        ))}
        <TableRow>
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell
            className={clsx(styles.tableEntryRows, styles.totalRowBorder, styles.amountColumnWidth)}
          >
            <Divider className={clsx(styles.totalOverline, styles.amountColumnWidth)} />
            <Typography
              variant={Typography.VARIANT.B4}
              weight={Typography.WEIGHT.MEDIUM}
              color={Typography.COLOR.PRIMARY}
              align={Typography.ALIGN.RIGHT}
            >
              {totalSourceAmount.toFixed(2)}
            </Typography>
          </TableCell>
          <TableCell
            className={clsx(styles.tableEntryRows, styles.totalRowBorder, styles.amountColumnWidth)}
          >
            <Divider className={clsx(styles.totalOverline, styles.amountColumnWidth)} />
            <Typography
              variant={Typography.VARIANT.B4}
              weight={Typography.WEIGHT.MEDIUM}
              color={Typography.COLOR.PRIMARY}
              align={Typography.ALIGN.RIGHT}
            >
              {totalTargetAmount.toFixed(2)}
            </Typography>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
